enum PRICE_SHOWN {
    TOTAL = 'total',
    NET = 'net',
    SHOWN = 'shown',
    // Is used only on cars
    CALCULATED = 'Calculated',
}

export default PRICE_SHOWN;
